const tryCatch = async (procAsync, exceptionHandler) => {
  try {
    return await procAsync?.();
  } catch (error) {
    if (exceptionHandler?.handle(error)) throw error;
  }
};

export default tryCatch;
